export default "__VITE_ASSET__Bvl$Hvf6__"